// extracted by mini-css-extract-plugin
export default {"card":"MegaMenuCard_card__b-ror","text":"MegaMenuCard_text__NsGjs","name":"MegaMenuCard_name__eqYFn","description":"MegaMenuCard_description__chRaI"};